import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { ManageAuctionsPageComponent } from './components/manage-auctions-page/manage-auctions-page.component';
import { ManageAutionPageAComponent } from './components/manage-aution-page-a/manage-aution-page-a.component';
import { AuctionsListComponent } from './components/auctions-list/auctions-list.component';
import { AuctionCardComponent } from './components/auction-card/auction-card.component';
import { AuctionsPopoverComponent } from './components/auctions-popover/auctions-popover.component';
import { AuctionItemCardComponent } from './components/auction-item-card/auction-item-card.component';
import { AuctionItemsFilterPopoverComponent } from './components/auction-items-filter-popover/auction-items-filter-popover.component';

import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { LetModule, PushModule } from '@ngrx/component';
import { IconModule } from '../icon/icon.module';
import { AuctionDetailModalComponent } from './modals/auction-detail-modal/auction-detail-modal.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import * as fromAuctions from './features/auction.reducer';
import { StoreModule } from '@ngrx/store';
import { CampaignAuctionEffects } from './features/auction.effects';
import { EffectsModule } from '@ngrx/effects';
import { AuctionBidderPopoverComponent } from './components/auction-bidder-popover/auction-bidder-popover.component';
import { AuctionUpdateBidderModalComponent } from './modals/auction-update-bidder-modal/auction-update-bidder-modal.component';
import { AuctionSeeBidderInfoModalComponent } from './modals/auction-see-bidder-info-modal/auction-see-bidder-info-modal.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { AuctionBidderDetailsComponent } from './components/auction-bidder-details/auction-bidder-details.component';
import { AuctionItemDetailsComponent } from './components/auction-item-details/auction-item-details.component';
import { AuctionSearchByBidderComponent } from './components/auction-search-by-bidder/auction-search-by-bidder.component';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CounterModule } from '../core/modules/counter/counter.module';
import { SharedLinkOptionPopoverComponent } from './components/shared-link-option-popover/shared-link-option-popover.component';
import { AuctionBidActivityComponent } from './components/auction-bid-activity/auction-bid-activity.component';
import { AuctionPaidTabComponent } from './components/auction-paid-tab/auction-paid-tab.component';
import { AuctionPendingTabComponent } from './components/auction-pending-tab/auction-pending-tab.component';
import { DataTablesModule } from 'angular-datatables';
import { AuctionBiddersTabComponent } from './components/auction-bidders-tab/auction-bidders-tab.component';
import { InitTooltipDirective } from './directives/init-tooltip.directive';

@NgModule({
  declarations: [
    ManageAuctionsPageComponent,
    ManageAutionPageAComponent,
    AuctionsListComponent,
    AuctionCardComponent,
    AuctionsPopoverComponent,
    AuctionItemCardComponent,
    AuctionItemsFilterPopoverComponent,
    AuctionDetailModalComponent,
    AuctionBidderPopoverComponent,
    AuctionUpdateBidderModalComponent,
    AuctionSeeBidderInfoModalComponent,
    AuctionBidderDetailsComponent,
    AuctionItemDetailsComponent,
    AuctionSearchByBidderComponent,
    SharedLinkOptionPopoverComponent,
  ],
  imports: [
    StoreModule.forFeature(fromAuctions.auctionFeatureKey, fromAuctions.reducer),
    EffectsModule.forFeature([CampaignAuctionEffects]),
    CommonModule,
    ReactiveFormsModule,
    CoreModule,
    MdbPopoverModule,
    MdbSelectModule,
    LetModule,
    PushModule,
    IconModule,
    MdbTabsModule,
    MdbTooltipModule,
    MdbAutocompleteModule,
    FormsModule,
    CounterModule,
    ClipboardModule,
    AuctionBidActivityComponent,
    AuctionPaidTabComponent,
    AuctionPendingTabComponent,
    AuctionBiddersTabComponent,
    DataTablesModule,
    InitTooltipDirective,
  ], 
  exports: [
    ManageAuctionsPageComponent,
    ManageAutionPageAComponent,
    AuctionsListComponent,
    AuctionCardComponent,
    AuctionsPopoverComponent,
    AuctionItemCardComponent,
    AuctionItemsFilterPopoverComponent,
    AuctionDetailModalComponent,
    FormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageAuctionsModule { }
